import React from "react";
import { motion } from "framer-motion";
import { Gift, FileText, ListChecks, Megaphone, Sparkles, Users, RefreshCcw } from "lucide-react";
import { BONUSES } from "@/constants/content";

const ICONS = [Gift, FileText, ListChecks, Megaphone, Sparkles, Users, RefreshCcw];

const Bonuses = () => (
  <section id="bonuses" className="section-pad relative">
    <div className="container-x">
      <div className="max-w-3xl">
        <div className="chip">Exclusive Bonuses</div>
        <h2 className="mt-3 font-display font-bold tracking-tight text-slate-900" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)" }}>
          Everything you get, <span className="gradient-text-emerald">on top of the marathon</span>.
        </h2>
      </div>

      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {BONUSES.map((b, i) => {
          const Icon = ICONS[i] || Gift;
          const featured = i === 0;
          return (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className={`relative rounded-3xl border p-6 overflow-hidden ${
                featured
                  ? "bg-gradient-to-br from-[#052e2b] to-[#0f172a] text-white border-white/10 lg:col-span-2"
                  : "bg-white border-slate-100 shadow-premium"
              }`}
            >
              {featured && <div className="aurora opacity-50" aria-hidden />}
              <div className="relative z-10 flex items-start justify-between gap-4">
                <div>
                  <div className={`text-[11px] font-mono uppercase tracking-widest ${featured ? "text-lime-300" : "text-emerald-700"}`}>
                    Bonus {String(i + 1).padStart(2, "0")}
                  </div>
                  <h3 className="mt-2 font-display font-bold text-xl sm:text-2xl">{b.title}</h3>
                  <p className={`mt-2 text-sm ${featured ? "text-white/80" : "text-slate-600"}`}>{b.body}</p>
                </div>
                <div
                  className={`w-12 h-12 rounded-2xl grid place-items-center shrink-0 border ${
                    featured
                      ? "bg-white/10 border-white/20 text-lime-300"
                      : "bg-emerald-50 border-emerald-100 text-emerald-700"
                  }`}
                >
                  <Icon className="w-5 h-5" />
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Bonuses;
